import React from 'react';
import { motion } from 'framer-motion';
const PainCard = ({
  icon,
  text,
  delay
}: {
  icon: string;
  text: string;
  delay: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true
}} transition={{
  delay,
  duration: 0.5
}} className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-coral-400 hover:shadow-md transition-shadow" data-id="element-83">
    <div className="text-4xl mb-4" data-id="element-84">{icon}</div>
    <p className="text-lg font-medium text-dark-800" data-id="element-85">{text}</p>
  </motion.div>;
export function PainSection() {
  return <section className="py-20 bg-white" data-id="element-86">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
        <div className="text-center mb-16" data-id="element-88">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark-900 mb-4" data-id="element-89">
            ¿Te identificas con esto?
          </h2>
          <div className="w-24 h-1 bg-coral-400 mx-auto rounded-full" data-id="element-90"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-91">
          <PainCard icon="😩" text="La hinchazón de las 6 PM que no desaparece" delay={0.1} data-id="element-92" />
          <PainCard icon="😴" text="Agotamiento mental que el café ya no cura" delay={0.2} data-id="element-93" />
          <PainCard icon="😤" text="Dietas que solo te cansan más" delay={0.3} data-id="element-94" />
          <PainCard icon="💔" text="Sentirte traicionada por tu propio cuerpo" delay={0.4} data-id="element-95" />
        </div>

        <div className="text-center max-w-3xl mx-auto" data-id="element-96">
          <p className="text-xl md:text-2xl text-dark-800 font-serif italic" data-id="element-97">
            "Si dijiste sí a alguna de estas... tu sistema de alerta está
            encendido.{' '}
            <span className="text-coral-600 font-bold not-italic" data-id="element-98">
              Y tiene solución.
            </span>
            "
          </p>
        </div>
      </div>
    </section>;
}